module.exports = __webpack_public_path__ + "img/drone_03_H.d317d388.webp";